import {
  DailyReportTaskStateTypes,
  DailyReportTaskActionTypes,
} from "./DailyReportTask.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: DailyReportTaskStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const DailyReportTaskReducer = (
  state: DailyReportTaskStateTypes = INITIAL_STATE,
  action: any
): DailyReportTaskStateTypes => {
  switch (action.type) {
    case DailyReportTaskActionTypes.FETCH_ALL_DAILY_REPORT_TASK:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case DailyReportTaskActionTypes.FETCH_ALL_DAILY_REPORT_TASK_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case DailyReportTaskActionTypes.FETCH_ALL_DAILY_REPORT_TASK_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case DailyReportTaskActionTypes.FETCH_ALL_DAILY_REPORT_TASK_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case DailyReportTaskActionTypes.FETCH_ONE_DAILY_REPORT_TASK:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case DailyReportTaskActionTypes.FETCH_ONE_DAILY_REPORT_TASK_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case DailyReportTaskActionTypes.FETCH_ONE_DAILY_REPORT_TASK_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case DailyReportTaskActionTypes.FETCH_ONE_DAILY_REPORT_TASK_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default DailyReportTaskReducer;
